export const mediaTypeConstants = {
    LIMIT_FIVE: 5,
    LIMIT_TEN: 10,
    LIMIT_TWENTY: 20,
    MEDIA_SAVE_TYPE: {
        value: "MEDIA_FILE",
        text: "MEDIA_FILE",
        translate: "code.article.file.type.media"
    },
    ATTACHED_SAVE_TYPE: {
        value: "ATTACHED_FILE",
        text: "ATTACHED_FILE",
        translate: "code.article.file.type.attached"
    },
    VIDEO_THUMBNAIL_SIZE: {
        small: 80,
        medium: 126,
        large_height: 437,
        large_width: 766
    }
};
